GP.GPMod('HotPickFilters',function(self) {
    var vent  = null;
    var _util = null;
    var _log  = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            _log  = self.app.Util.log;
        },
        loc_obj: {}
    };

    var events = {
        setup_hotpick_filters_modal: function() {
            data.init();
            events.setup_typeahead();
            events.setup_age_slider();
            events.setup_radius_slider();

            $(document).on('change', '.hp_checkbox_interest', function() {
                $('#hp-interested-in-changed').val(1);
            });
        },
        setup_typeahead: function() {
            var _module_data = data;
            $('#hotpick-filter-loc').typeahead({
                items: "all",
                minLength: 3,
                fitToElement: true,
                source: function(query, process) {
                    var country_code = $('#hotpick-filter-cc').val();
                    return $.get('/members/geo/suggest_cities_all/?jq=1&country_code='+country_code, { location_name: query }, function(data) {
                        _module_data.loc_obj = {};
                        var names = [];

                        $.map(data, function(val, i) {
                            if (Boolean(val.country_code)) {
                                var _location = '';
                                if (val.country_code == 'US' || val.country_code == 'CA') {
                                    _location = val.city_name + ', ' + val.state_code;
                                } else {
                                    _location = val.city_name + ', ' + val.country_code;
                                }
                                names.push(_location);
                                _module_data.loc_obj[_location] = val.location_id;
                            }
                        });
                        return process(names);
                    });
                },
                updater: function(name) {
                    $('#hotpick-filter-location-id').val(data.loc_obj[name]);
                    return name;
                }
            });
        },
        setup_age_slider: function() {
            var age_slider = document.getElementById('hotpick-age-slider');
            var age_start  = _modal_vars.slider_age_start;
            var age_end    = _modal_vars.slider_age_end;
            
            noUiSlider.create(age_slider, {
                range: {
                    min: 18,
                    max: 100
                },
                step: 1,
                start: [age_start, age_end],
                connect: true,
                behaviour: 'tap-drag',
                tooltips: [true, true],
                format: {
                    to: function(val) {
                        return parseInt(val);
                    },
                    from: function(val) {
                        return parseInt(val);
                    }
                }
            });

            age_slider.noUiSlider.on('slide', function(val) {
                $('#hotpick-age-start').val(val[0]);
                $('#hotpick-age-end').val(val[1]);

                $('#hp-age-min').text(val[0]);
                $('#hp-age-max').text(val[1]);
            });
        },
        setup_radius_slider: function() {
            var _radius_slider = document.getElementById('hotpick-radius-slider');
            var _radius  = _modal_vars.slider_radius;

            noUiSlider.create(_radius_slider, {
                range: {
                    min: 10,
                    max: 3000
                },
                step: 1,
                start: [_radius],
                connect: 'lower',
                behaviour: 'tap-drag',
                tooltips: {
                    to: function(val) {
                        return parseInt(val) + 'mi';
                    },
                    from: function(val) {
                        return parseInt(val);
                    }
                },
                format: {
                    to: function(val) {
                        return parseInt(val);
                    },
                    from: function(val) {
                        return parseInt(val);
                    }
                }
            });

            _radius_slider.noUiSlider.on('slide', function(val) {
                $('#hotpick-radius').val(val[0]);
            });
        }
    };

    this.addInitializer(function() {
        data.init();

        self.vent.on(self.moduleName+":setup_hotpick_filters_modal", events.setup_hotpick_filters_modal, this);
    });
});
